import { Component, OnInit } from '@angular/core';

import { DLPRestUtilityService } from '../../services/rest/dlprest-utility.service';
import { LoginRenderingService } from '../../services/login/login-rendering.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationLabelEN } from 'src/app/models/labels/notificationLabel_EN';


@Component({
  selector: 'app-pre-approval-notification',
  templateUrl: './pre-approval-notification.component.html',
  styleUrls: ['./pre-approval-notification.component.scss']
})
export class PreApprovalNotificationComponent implements OnInit {
  prevResponse: any = new Object();
  send = [];
  cardBodyLength: boolean = false;
  show: boolean = false;
  noNewNotification: boolean = false;
  label: NotificationLabelEN;

  constructor(private dlprestService: DLPRestUtilityService, private loginRenderingService: LoginRenderingService) { }

  ngOnInit() {
    this.loginRenderingService.login.checkHomePage = true;
    this.label = new NotificationLabelEN();

    this.dlprestService.notification().subscribe((res) => {
      let data = res;
      // console.log(data);
      this.prevResponse = data;

      this.prevResponse.show = false;

      if (this.prevResponse.preapprovalStatus.length > 9) {
        this.cardBodyLength = true;
      }

      if (this.prevResponse.preapprovalStatus.length == 0) {
        this.noNewNotification = true;
      }

      this.prevResponse.preapprovalStatus.forEach(element => {
        element.spinner = false;
      });

      this.show = true;
      // this.prevResponse[0].show = true;

    },
      (err: HttpErrorResponse) => {
        console.log('', err);
        if (err.error instanceof Error) {
          // A client-side or network error occurred.
          console.log('An error occurred:', err.error.message);
        } else {
          //  Backend returns unsuccessful response codes such as 404, 500 etc.
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);

        }
        this.show = false;
      }

    );
  }


  arrowChange(element) {
    this.prevResponse.show = !this.prevResponse.show;
  }

  approvedOrRejected(element) {
    if (element == "Y") {
      return "has been Auto-Approved!";
    } else {
      return "is being processed and NOT Auto-Approved!";
    }
  }

  clearAll() {
    this.prevResponse.preapprovalStatus.forEach(element => {
      this.send.push(element.applicationNo);
    });;
    this.postDeleteNotification(this.send);
  }

  remove(applicationNo) {
    this.send.push(applicationNo);
    this.postDeleteNotification(this.send);
  }

  postDeleteNotification(send) {
    // console.log(send);
    this.prevResponse.preapprovalStatus.forEach((element, i) => {
      send.forEach((deleteElement) => {
        if (element.applicationNo == deleteElement) {
          element.spinner = true;
        }
      })
    });

    this.dlprestService.deleteNotification(this.send).subscribe((res) => {
      let data = res;

      send.forEach((deleteElement) => {
        this.prevResponse.preapprovalStatus.forEach((element, i) => {
          if (element.applicationNo == deleteElement) {
            // console.log(element);
            this.prevResponse.preapprovalStatus.splice(i, 1);
          }
        })
      });
      this.send = [];
    },
      (err: HttpErrorResponse) => {
        console.log('', err);
        if (err.error instanceof Error) {
          // A client-side or network error occurred.
          console.log('An error occurred:', err.error.message);
        } else {
          //  Backend returns unsuccessful response codes such as 404, 500 etc.
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }

        send.forEach((deleteElement) => {
          this.prevResponse.preapprovalStatus.forEach((element, i) => {
            if (element.applicationNo == deleteElement) {
              element.spinner = false;
            }
          })
        });
        this.send = [];
      }
    );
  }

  disableCheck() {
    if (this.prevResponse) {
      if (this.prevResponse.preapprovalStatus.length == 0) {
        return true;
      } else { return false; }
    } else {
      return true;
    }
  }
}
